// frontend/src/components/NavigationTracker.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Get current path
        const currentPath = location.pathname;
        
        // Get previous paths from sessionStorage
        const previousPaths = JSON.parse(sessionStorage.getItem('navigationHistory') || '[]');
        
        // Check if current path is different from last stored path
        if (previousPaths[previousPaths.length - 1] !== currentPath) {
            // Add current path to history
            previousPaths.push(currentPath);
            
            // Keep only the last 10 paths to prevent excessive storage
            if (previousPaths.length > 10) {
                previousPaths.shift();
            }
            
            // Save updated history back to sessionStorage
            sessionStorage.setItem('navigationHistory', JSON.stringify(previousPaths));
            
            // Also store the previous path separately for easy access
            if (previousPaths.length > 1) {
                sessionStorage.setItem('prevPath', previousPaths[previousPaths.length - 2]);
            }

            // Store the current path as the last visited path
            sessionStorage.setItem('currentPath', currentPath);
        }

        // Cleanup function to update last path when component unmounts
        return () => {
            const paths = JSON.parse(sessionStorage.getItem('navigationHistory') || '[]');
            if (paths.length > 0) {
                sessionStorage.setItem('lastPath', paths[paths.length - 1]);
            }
        };
    }, [location]);

    useEffect(() => {
        // Initialize history if it doesn't exist
        if (!sessionStorage.getItem('navigationHistory')) {
            sessionStorage.setItem('navigationHistory', JSON.stringify([location.pathname]));
            sessionStorage.setItem('currentPath', location.pathname);
        }
    }, []);

    // This component doesn't render anything visible
    return null;
};

export default NavigationTracker;